export default __webpack_public_path__ + "static/media/ellipse.d598e171.svg";